module.exports = __webpack_public_path__ + "static/media/success.d9123377.svg";